import React from "react";
import Lottie from "lottie-react";
import animationData from "../../images/Animation - 1729588660128.json";
import "./Preloader.css"; // Добавьте эту строку в начало файла

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="preloader">
        <Lottie
          animationData={animationData}
          loop={true}
          autoplay={true}
          style={{ width: 400, height: 400 }}
        />
      </div>
    </div>
  );
};

export default Preloader;
